import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQs: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "What is Wenergie?",
      answer: "Wenergie is a next-generation electricity company. Like your utility company, but better and cooler. We help you access clean energy, track your usage in real time, and earn rewards for smarter choices.",
    },
    {
      question: "What are plans, and is there a monthly subscription for each plan?",
      answer: "Wenergie offers tailored plans for different types of homes — with solar, with EVs, or general households. These are not subscription-based; you pay for the ReDER device once, and then access clean energy and rewards with no monthly fees.",
    },
    {
      question: "How do I know which plan is right for me?",
      answer: "We've made it simple — just take a quick quiz on our website, and we'll recommend the right plan and ReDER configuration for your home.",
    },
    {
      question: "Can I join Wenergie if I live in a flat/Apartment?",
      answer: "Yes! You don't need a rooftop or driveway. Wenergie works for apartments and flats, allowing you to participate in clean energy usage and earn rewards.",
    },
    {
      question: "I live in a rented home. Are there any plans for me?",
      answer: "Absolutely. Wenergie is designed to work in rented homes too. ReDER comes with a no-drill installation option, making it easy to set up without permanent changes.",
    },
    {
      question: "What if I want to shift homes?",
      answer: "No problem! You can take your ReDER with you when you move. It's designed for easy reinstallation and portability.",
    },
    {
      question: "What is ReDER?",
      answer: "ReDER is your personal energy assistant. It's a compact device that tracks your home's energy usage in real time and helps connect you to clean energy and the Wenergie rewards program.",
    },
    {
      question: "Do I need to install solar panels/ own an EV to use Wenergie?",
      answer: "Not at all. You can benefit from clean energy and rewards even without solar panels or an EV. Wenergie has plans for every kind of home.",
    },
    {
      question: "I already have solar panels. Will this work with my existing rooftop solar system?",
      answer: "Yes. Wenergie is compatible with most major solar brands. If needed, we'll recommend a ReDER Companion to help connect your system to our network.",
    },
    {
      question: "What kind of rewards can I earn?",
      answer: "You earn Wenergie Coins by using clean energy smartly. These can be redeemed in the rewards store for discounts, goodies, or services.",
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Frequently Asked Questions</h2>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-gray-500" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-gray-500" />
                )}
              </button>
              <div
                className={`px-6 pb-4 transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;